export const css = {
	root: '_36CY5JM6',
	tabButtons: '_349QFQj1',
	tabButton: '_3FIHMFV1',
	disabledTabButton: 'liKY0vLe',
	activeTabButton: '_2V0o3JZ5',
	close: '_1XvOI9_m',
	closeable: '_1faLGzjC',
	tab: 'c7dZzldE',
	alignLeft: 'n2K6bnLR',
	tabs: '_1NYd0I3w',
	alignRight: '_1V2vplYE',
	alignBottom: '_3vEL5d95',
	' _key': 'afcpe-theme/dojo/tab-container'
};

export default css;
